import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { useGetPointOfSaleDataQuery } from '../CheckoutApi';

export default function useExtraSalePoints() {
  const { data, status } = useGetPointOfSaleDataQuery();

  return {
    extraSalePoints: data?.extraSalePoints,
    status,
    ...convertStatusTypeToObject(status),
  };
}
